import {
    CREATE_PRINTING2_INWARD_MASTER_REQUEST_DK,
    CREATE_PRINTING2_INWARD_MASTER_SUCCESS_DK,
    CREATE_PRINTING2_INWARD_MASTER_FAILURE_DK,
    DELETE_PRINTING2_INWARD_MASTER_REQUEST_DK,
    DELETE_PRINTING2_INWARD_MASTER_SUCCESS_DK,
    DELETE_PRINTING2_INWARD_MASTER_FAILURE_DK,
    FETCH_SINGLE_PRINTING2_INWARD_MASTER_REQUEST_DK,
    FETCH_SINGLE_PRINTING2_INWARD_MASTER_SUCCESS_DK,
    FETCH_SINGLE_PRINTING2_INWARD_MASTER_FAILURE_DK,
    FETCH_PRINTING2_INWARD_MASTER_REQUEST_DK,
    FETCH_PRINTING2_INWARD_MASTER_SUCCESS_DK,
    FETCH_PRINTING2_INWARD_MASTER_FAILURE_DK,
    UPDATE_PRINTING2_INWARD_MASTER_REQUEST_DK,
    UPDATE_PRINTING2_INWARD_MASTER_SUCCESS_DK,
    UPDATE_PRINTING2_INWARD_MASTER_FAILURE_DK,
    RESET_PRINTING2_INWARD_MASTER_INFO_DK,
    CREATE_PRINTING2_INWARD_MASTER_FORM_DK,
    UPDATE_PRINTING2_INWARD_MASTER_FORM_DK,
    NAVIGATE_PRINTING2_INWARD_DETAILS_DK,
    NAVIGATE_PRINTING2_INWARD_MASTER_DK,
    FETCH_PENDING_PRINTING2_PO_IN_INWARD_REQUEST_DK,
    FETCH_PENDING_PRINTING2_PO_IN_INWARD_SUCCESS_DK,
    FETCH_PENDING_PRINTING2_PO_IN_INWARD_FAILURE_DK,
    SET_ACTIVE_KEY_PRINTING2_INWARD_DK,
    RESET_FORM_DATA_WITHOUT_PRINTING2_INWARD_ID_DK,
    FETCH_PRINTING2_INWARD_MASTER_EDIT_QUANTITY_REQUEST_DK,
    FETCH_PRINTING2_INWARD_MASTER_EDIT_QUANTITY_SUCCESS_DK,
    FETCH_PRINTING2_INWARD_MASTER_EDIT_QUANTITY_FAILURE_DK,
    RESET_EDIT_QUANTITY_GRID_DATA_WITHOUT_PRINTING2_INWARD_ID_DK,
    CREATE_PRINTING2_INWARD_EDIT_QTY_MASTER_REQUEST_DK,
    CREATE_PRINTING2_INWARD_EDIT_QTY_MASTER_SUCCESS_DK,
    CREATE_PRINTING2_INWARD_EDIT_QTY_MASTER_FAILURE_DK
} from './printing2InwardHeader.actionsType';

export const PRINTING2_INWARD_DK_MASTER = 'printing2InwardDKHeader';

let initialState = {
    loading: false,
    printing2InwardHeader: [],
    printing2InwardHeaderEditQuantity: [],
    pendingPrinting2Dc: [],
    activeKey: 1,
    printing2InwardId: '',
    detailsId: [],
    styleData: {},
    printing2InwardHeaderForm: {
        fldSupplierInvoiceNo: null,
        fldSupplierInvoiceDate: null,
        fldSupplierInvoiceValue: null,
        fldSupplierDCNo: null,
        fldSupplierDCDate: null,
        fldSupplierDCValue: null,
        fldGrossValue: 0,
        fldDiscountValue: 0,
        fldDiscountPercentage: 0,
        fldIGSTValue: 0,
        fldSGSTValue: 0,
        fldCGSTValue: 0,
        fldTaxableValue: 0,
        fldGSTValue: 0,
        fldSGSTPercentage: 0,
        fldCGSTPercentage: 0,
        fldIGSTPercentage: 0
    },
    selectedState: {},
    typeOfPoList: [],
    sourceList: [],
    departmentList: [],
    deliveryAt: [],
    errorMessage: '',
    singlePrinting2InwardData: {},
    isPrinting2InwardDetails: false
};

export let printing2InwardDKHeaderReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_PRINTING2_INWARD_MASTER_REQUEST_DK:
        case FETCH_PRINTING2_INWARD_MASTER_EDIT_QUANTITY_REQUEST_DK:
        case FETCH_PENDING_PRINTING2_PO_IN_INWARD_REQUEST_DK:
        case CREATE_PRINTING2_INWARD_MASTER_REQUEST_DK:
        case CREATE_PRINTING2_INWARD_EDIT_QTY_MASTER_REQUEST_DK:
        case UPDATE_PRINTING2_INWARD_MASTER_REQUEST_DK:
        case FETCH_SINGLE_PRINTING2_INWARD_MASTER_REQUEST_DK:
        case DELETE_PRINTING2_INWARD_MASTER_REQUEST_DK:
            return {
                ...state,
                loading: true
            };
        case FETCH_PRINTING2_INWARD_MASTER_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                printing2InwardHeader: updatePayload
            };
        case FETCH_PRINTING2_INWARD_MASTER_EDIT_QUANTITY_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                printing2InwardHeaderEditQuantity: updatePayload?.CUD,
                activeKey: 2
            };
        case FETCH_PENDING_PRINTING2_PO_IN_INWARD_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                pendingPrinting2Dc: updatePayload
            };
        case CREATE_PRINTING2_INWARD_MASTER_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                printing2InwardHeaderForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierDCValue: null,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldDiscountPercentage: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0
                },
                printing2InwardId: payload[0]?.fldID,
                detailsId: payload,
                activeKey: 2
            };
        case CREATE_PRINTING2_INWARD_EDIT_QTY_MASTER_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                printing2InwardHeaderForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierDCValue: null,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldDiscountPercentage: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0
                },
                activeKey: 1,
                detailsId: []
            };
        case UPDATE_PRINTING2_INWARD_MASTER_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                printing2InwardHeaderForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierDCValue: null,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldDiscountPercentage: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0
                }
            };
        case FETCH_SINGLE_PRINTING2_INWARD_MASTER_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                printing2InwardHeaderForm: {
                    ...payload,
                    fldSupplierInvoiceDate: payload?.fldSupplierInvoiceDate && payload?.fldSupplierInvoiceDate.split('T')[0],
                    fldSupplierDCDate: payload?.fldSupplierDCDate && payload?.fldSupplierDCDate.split('T')[0]
                }
            };
        case DELETE_PRINTING2_INWARD_MASTER_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                printing2InwardHeaderForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierDCValue: null,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldDiscountPercentage: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0
                }
            };
        case RESET_PRINTING2_INWARD_MASTER_INFO_DK:
            return {
                ...state,
                printing2InwardHeaderForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierDCValue: null,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldDiscountPercentage: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0
                },
                // printing2InwardId: '',
                styleData: {},
                activeKey: 1
            };
        case CREATE_PRINTING2_INWARD_MASTER_FORM_DK:
        case UPDATE_PRINTING2_INWARD_MASTER_FORM_DK:
            return {
                ...state,
                loading: false,
                printing2InwardHeaderForm: {
                    ...state.printing2InwardHeaderForm,
                    [payload.key]: payload.value
                }
            };
        case SET_ACTIVE_KEY_PRINTING2_INWARD_DK:
            return {
                ...state,
                loading: false,
                activeKey: 1
            };
        case RESET_EDIT_QUANTITY_GRID_DATA_WITHOUT_PRINTING2_INWARD_ID_DK:
            return {
                ...state,
                loading: false,
                printing2InwardHeaderEditQuantity: [],
                detailsId: []
            };
        case FETCH_PRINTING2_INWARD_MASTER_FAILURE_DK:
        case FETCH_PRINTING2_INWARD_MASTER_EDIT_QUANTITY_FAILURE_DK:
        case FETCH_PENDING_PRINTING2_PO_IN_INWARD_FAILURE_DK:
        case CREATE_PRINTING2_INWARD_MASTER_FAILURE_DK:
        case CREATE_PRINTING2_INWARD_EDIT_QTY_MASTER_FAILURE_DK:
        case UPDATE_PRINTING2_INWARD_MASTER_FAILURE_DK:
        case FETCH_SINGLE_PRINTING2_INWARD_MASTER_FAILURE_DK:
        case DELETE_PRINTING2_INWARD_MASTER_FAILURE_DK:
            return {
                ...state,
                loading: false
            };
        case RESET_FORM_DATA_WITHOUT_PRINTING2_INWARD_ID_DK:
            return {
                ...state,
                printing2InwardHeaderForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierDCValue: null,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldDiscountPercentage: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0
                },
                selectedTeam: {}
            };
        case NAVIGATE_PRINTING2_INWARD_DETAILS_DK:
            return {
                ...state,
                isPrinting2InwardDetails: true,
                singlePrinting2InwardData: updatePayload.singlePrinting2InwardData
            };
        case NAVIGATE_PRINTING2_INWARD_MASTER_DK:
            return {
                ...state,
                isPrinting2InwardDetails: false
            };
        default:
            return state;
    }
};
